import React from 'react';
import { motion } from 'framer-motion';

export function WarrantyPhilosophy() {
  return (
    <section className="bg-gradient-to-r from-teal-500 to-green-500 text-white py-20 px-6 relative overflow-hidden">
      {/* Decorative wave pattern */}
      <div className="absolute inset-0 opacity-10">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className="w-full h-full">
          <path fill="#ffffff" fillOpacity="1" d="M0,128L48,144C96,160,192,192,288,197.3C384,203,480,181,576,165.3C672,149,768,139,864,154.7C960,171,1056,213,1152,218.7C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
        </svg>
      </div>

      <motion.div 
        className="max-w-4xl mx-auto space-y-8 relative z-10"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
      >
        <div className="mb-8">
          <motion.h2 
            className="text-3xl md:text-4xl font-bold text-center"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.5 }}
          >
            Why We Offer a Warranty
          </motion.h2>
          <div className="h-1 w-32 bg-white bg-opacity-50 mx-auto mt-3 rounded-full"></div>
        </div>

        <motion.p 
          className="text-lg md:text-xl leading-relaxed max-w-2xl mx-auto text-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.5 }}
        >
          Because we believe in our work—and in you. Our dental warranty is a reflection of the confidence we have in our care, our materials, and our commitment to long-term oral health.
        </motion.p>
        
        <motion.div 
          className="pt-8 flex flex-wrap justify-center gap-12 mt-8"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6, duration: 0.5 }}
        >
          <div className="flex flex-col items-center text-center">
            <div className="w-20 h-20 relative flex items-center justify-center mb-4">
              <div className="absolute inset-0 bg-teal-300 bg-opacity-20 rounded-lg shadow-lg transform rotate-12"></div>
              <div className="absolute inset-0 bg-green-300 bg-opacity-30 rounded-lg shadow-lg transform -rotate-12"></div>
              <div className="absolute inset-0 bg-white bg-opacity-30 rounded-lg shadow-lg filter blur-sm"></div>
              <div className="w-12 h-12 rounded-md bg-gradient-to-br from-teal-400 to-green-400 flex items-center justify-center z-10">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
            </div>
            <h3 className="font-bold">Quality Assurance</h3>
          </div>
          
          <div className="flex flex-col items-center text-center">
            <div className="w-20 h-20 relative flex items-center justify-center mb-4">
              <div className="absolute inset-0 bg-teal-300 bg-opacity-20 rounded-lg shadow-lg transform rotate-12"></div>
              <div className="absolute inset-0 bg-green-300 bg-opacity-30 rounded-lg shadow-lg transform -rotate-12"></div>
              <div className="absolute inset-0 bg-white bg-opacity-30 rounded-lg shadow-lg filter blur-sm"></div>
              <div className="w-12 h-12 rounded-md bg-gradient-to-br from-teal-400 to-green-400 flex items-center justify-center z-10">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
            </div>
            <h3 className="font-bold">Long-Term Investment</h3>
          </div>
          
          <div className="flex flex-col items-center text-center">
            <div className="w-20 h-20 relative flex items-center justify-center mb-4">
              <div className="absolute inset-0 bg-teal-300 bg-opacity-20 rounded-lg shadow-lg transform rotate-12"></div>
              <div className="absolute inset-0 bg-green-300 bg-opacity-30 rounded-lg shadow-lg transform -rotate-12"></div>
              <div className="absolute inset-0 bg-white bg-opacity-30 rounded-lg shadow-lg filter blur-sm"></div>
              <div className="w-12 h-12 rounded-md bg-gradient-to-br from-teal-400 to-green-400 flex items-center justify-center z-10">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5" />
                </svg>
              </div>
            </div>
            <h3 className="font-bold">Patient Confidence</h3>
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
}